import React from 'react';
import { Shield, Lock, Eye, Database, UserCheck, Mail, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const PoliticaPrivacidadPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-zinc-50 to-white pt-24 pb-16">
      <div className="max-w-4xl mx-auto px-6">
        {/* Header */}
        <div className="mb-12">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-zinc-500 hover:text-[#14532D] transition-colors mb-6"
          >
            <ArrowLeft size={18} />
            Volver al inicio
          </Link>
          
          <div className="flex items-center gap-4 mb-6">
            <div className="bg-[#90EE90]/20 p-4 rounded-2xl">
              <Shield className="text-[#14532D] w-8 h-8" />
            </div>
            <div>
              <h1 className="text-3xl md:text-4xl font-bold text-zinc-900">Política de Privacidad</h1>
              <p className="text-zinc-500 mt-1">Última actualización: Marzo 2026</p>
            </div>
          </div>
          
          <p className="text-lg text-zinc-600 leading-relaxed">
            En Zenex Paraguay, nos comprometemos a proteger tu privacidad y la seguridad de tus datos personales. 
            Esta política describe cómo recopilamos, usamos y protegemos tu información.
          </p>
        </div>

        {/* Content */}
        <div className="space-y-10">
          {/* Section 1 */}
          <section className="bg-white rounded-2xl border border-zinc-200 p-8">
            <div className="flex items-center gap-3 mb-4">
              <Database className="text-[#90EE90] w-6 h-6" />
              <h2 className="text-xl font-bold text-zinc-900">1. Información que Recopilamos</h2>
            </div>
            <div className="text-zinc-600 space-y-4">
              <p>Recopilamos información cuando:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Completas el formulario de contacto o solicitas una cotización</li>
                <li>Usas nuestra calculadora solar</li>
                <li>Te suscribes a nuestro newsletter</li>
                <li>Interactúas con nuestro chatbot</li>
              </ul>
              <p className="mt-4">
                <strong>Datos que podemos recopilar:</strong> Nombre, email, teléfono, dirección, 
                consumo eléctrico estimado, tipo de propiedad y mensajes que nos envíes.
              </p>
            </div>
          </section>

          {/* Section 2 */}
          <section className="bg-white rounded-2xl border border-zinc-200 p-8">
            <div className="flex items-center gap-3 mb-4">
              <Eye className="text-[#90EE90] w-6 h-6" />
              <h2 className="text-xl font-bold text-zinc-900">2. Cómo Usamos tu Información</h2>
            </div>
            <div className="text-zinc-600 space-y-4">
              <p>Utilizamos tu información para:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Responder a tus consultas y solicitudes de cotización</li>
                <li>Personalizar tu experiencia en nuestro sitio</li>
                <li>Enviarte información sobre nuestros servicios y promociones (si lo autorizas)</li>
                <li>Mejorar nuestros servicios y atención al cliente</li>
                <li>Cumplir con obligaciones legales</li>
              </ul>
            </div>
          </section>

          {/* Section 3 */}
          <section className="bg-white rounded-2xl border border-zinc-200 p-8">
            <div className="flex items-center gap-3 mb-4">
              <Lock className="text-[#90EE90] w-6 h-6" />
              <h2 className="text-xl font-bold text-zinc-900">3. Protección de Datos</h2>
            </div>
            <div className="text-zinc-600 space-y-4">
              <p>
                Implementamos medidas de seguridad técnicas y organizativas para proteger tus datos personales 
                contra acceso no autorizado, alteración, divulgación o destrucción.
              </p>
              <p>
                <strong>Nuestras medidas incluyen:</strong>
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Encriptación de datos en tránsito (HTTPS)</li>
                <li>Acceso restringido a la información personal</li>
                <li>Servidores seguros con monitoreo constante</li>
                <li>Capacitación del personal en protección de datos</li>
              </ul>
            </div>
          </section>

          {/* Section 4 */}
          <section className="bg-white rounded-2xl border border-zinc-200 p-8">
            <div className="flex items-center gap-3 mb-4">
              <UserCheck className="text-[#90EE90] w-6 h-6" />
              <h2 className="text-xl font-bold text-zinc-900">4. Tus Derechos</h2>
            </div>
            <div className="text-zinc-600 space-y-4">
              <p>Tenés derecho a:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li><strong>Acceder</strong> a tus datos personales que tenemos almacenados</li>
                <li><strong>Rectificar</strong> información incorrecta o desactualizada</li>
                <li><strong>Eliminar</strong> tus datos de nuestra base de datos</li>
                <li><strong>Oponerte</strong> al procesamiento de tus datos</li>
                <li><strong>Retirar</strong> tu consentimiento en cualquier momento</li>
              </ul>
            </div>
          </section>

          {/* Section 5 */}
          <section className="bg-white rounded-2xl border border-zinc-200 p-8">
            <div className="flex items-center gap-3 mb-4">
              <Mail className="text-[#90EE90] w-6 h-6" />
              <h2 className="text-xl font-bold text-zinc-900">5. Contacto</h2>
            </div>
            <div className="text-zinc-600 space-y-4">
              <p>
                Si tenés preguntas sobre esta política de privacidad o querés ejercer tus derechos, 
                podés contactarnos:
              </p>
              <div className="bg-zinc-50 rounded-xl p-6 mt-4">
                <p><strong>Email:</strong> zenexparaguay@gmail.com</p>
                <p><strong>WhatsApp:</strong> +595 991 344956</p>
                <p><strong>Dirección:</strong> Facundo Machain 7390, casi Francis Morices, Asunción, Paraguay</p>
              </div>
            </div>
          </section>
        </div>

        {/* Footer note */}
        <div className="mt-12 text-center text-zinc-500 text-sm">
          <p>
            Esta política de privacidad puede ser actualizada periódicamente. 
            Te recomendamos revisarla regularmente.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PoliticaPrivacidadPage;
